import React from "react";
import { Modal, Nav } from "react-bootstrap";
import "./ModalHeader.scss";

interface Tabs {
  tabs: Array<[string, string]>;
  title?: never;
}

interface Title {
  tabs?: never;
  title: string;
}

// Union trick https://stackoverflow.com/a/61281828/193886
const ModalHeader = ({ tabs, title }: Tabs | Title) => (
  <Modal.Header closeButton className={title ? "b-b" : "px-2 py-0"}>
    {title ? (
      <Modal.Title>{title}</Modal.Title>
    ) : (
      <Nav className="dfi-tabs">
        {tabs?.map(([key, value]) => (
          <Nav.Item key={key}>
            <Nav.Link eventKey={key}>{value}</Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    )}
  </Modal.Header>
);
export default ModalHeader;
